import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from 'src/actions/name.actions';
import { actions } from 'src/actions/main.actions';
import { actions as homeActions } from 'src/actions/home.actions';
import Icon from 'src/core/ui/icon';
import Modal from 'src/core/ui/modal';
import Button from 'src/core/ui/button';
import { resolve } from 'inversify-react';
import IdentityService from 'src/services/identity.service';
import IconBtn from 'src/core/ui/icon-btn';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import HttpService from 'src/services/http.service';
import Fade from 'react-reveal/Fade';

import { scroller } from 'react-scroll'
import { AppLocation, IApplicationState } from "../../typings";

interface IMobileMenuProps {
    appLocation: AppLocation;
    history: History;
}

type MobileMenuProps = IMobileMenuProps & typeof actions & typeof homeActions & RouteComponentProps<any>;
interface IMobileMenuState{
    menuOpen: boolean;
}

class MobileMenu extends React.Component<MobileMenuProps, IMobileMenuState>{

    @resolve
    identity: IdentityService;

    @resolve(HttpService)
    httpService: HttpService;

    constructor(props: any){
    super(props);
        this.state =  {
            menuOpen: false
        }
    }

    handleLogin = () => {
        this.setState({menuOpen: false});
        this.props.toggleLogin(true, 0);
    }

    handleSignUp = () => {

        this.setState({menuOpen: false});
        this.props.toggleLogin(true, 1);
    }

    getActiveClass = (location: string) =>{
        if(this.props.appLocation == location)
            return 'selected';
        return '';
    }

    navigateTo = (path, appLocation?: AppLocation) => {
        this.props.history.push(path);
        this.setState({menuOpen: false});

        if(appLocation)
            this.props.changeLocation(appLocation)
    }


  scrollTo = (path: string, id: string, appLocation?: AppLocation) => {
    this.props.history.push(path);

    scroller.scrollTo(id, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    })

    this.setState({menuOpen: false});
  }

  renderUserNav = () => {
      return [
        <li key='collection'><p><a className={this.getActiveClass('arts')} onClick={() => this.navigateTo('/arts', 'arts')} >Gallery</a></p></li>,
        <li key='collection'><p><a className={this.getActiveClass('collection')} onClick={() => this.navigateTo('/account/collection', 'collection')} >Collection</a></p></li>,
        // <li key='wallet'><p><a className={this.getActiveClass('wallet')} onClick={() => this.navigateTo('/wallet', 'wallet')} >Wallet</a></p></li>,
        <li key='balance'><p><a className={this.getActiveClass('balance')} onClick={() => this.navigateTo('/account/balance', 'balance')} >Account</a></p></li>,
        <li key='settings'><p><a className={this.getActiveClass('settings')} onClick={() => this.navigateTo('/account/settings', 'settings')} >Settings</a></p></li>,
        <li key='home'><p><a  onClick={() =>
            {
                this.identity.logout();
                this.navigateTo('/', 'home')
            }
        } >Log out</a></p></li>,
      ];
  }

    public render(){
        const url = `${this.httpService.domainUrl}/${this.props.location.pathname}`;

        return (<React.Fragment>
            <div className='mobile-menu'>
                <Icon type='menu1' style={{cursor: 'pointer'}} onClick={() => this.setState({menuOpen: !this.state.menuOpen})} />
            </div>
            <Modal
                type='dark'
                size='complete'
                closable
                className='fixed'
                style={{zIndex: 99999}}
                visible={this.state.menuOpen}
                onCancel={() => this.setState({menuOpen: false})}
            >
                <div className='mobile-menu-container'>
                    <div className='nav-container'>
                        <Fade top>
                            <ul className='mobile-nav'>
                                <li key='home'><p><a onClick={() => this.navigateTo('/', 'home')} className={this.getActiveClass('home')}>Home</a></p></li>
                                {/*!this.identity.isAuthenticated() && <li key='arts'><p><a onClick={() => this.navigateTo('/arts')} className={this.getActiveClass('arts')}>Gallery</a></p></li>*/}
                                {!this.identity.isAuthenticated() && <li key='why_us'><p><a onClick={() => this.scrollTo('/', "why_us", 'home')} >For collectors</a></p></li>}
                                {!this.identity.isAuthenticated() && <li key='vision'><p><a onClick={() => this.scrollTo('/',"our_vision", 'home')}>Our vision</a></p></li>}
                                {!this.identity.isAuthenticated() && <li key='team'><p><a onClick={() => this.scrollTo('/', "our_team", 'home')}>Our Team</a></p></li>}
                                {this.identity.isAuthenticated() && this.renderUserNav()}
                            </ul>
                        </Fade>
                        <div className='share-container'>
                            <Fade bottom>
                                <IconBtn  key='twitBtn' type='twitter' url="https://twitter.com/EncryptoArt" />
                            </Fade>
                            <Fade right>
                                <IconBtn className='' key='insBtn' type='instagram' url="https://www.instagram.com/encrypto_official/" />
                            </Fade>
                        </div>
                    </div>
                    {!this.identity.isAuthenticated() && <div className='mobile-login'>
                        <Button onClick={this.handleLogin} presentation='dark'>LOG IN</Button>
                        <Button onClick={this.handleSignUp} presentation='dark' >SIGN UP</Button>
                    </div>}
                </div>

                </Modal>

        </React.Fragment>);
    }

}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        location: state.routing.location || ownProps.location,
        appLocation: state.appLocation,
        ...ownProps
        }
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(withRouter(MobileMenu));



// WEBPACK FOOTER //
// ./src/components/navigation/mobile-menu.tsx